export default {
    methods : {
        handleOptionClick(event) {
            if (event.target.tagName === 'IMG') {
                event.stopPropagation();
                this.$emit('lightbox', event.target.src);
            }
        },
    },
};
